/**
 * HERE returns ISO 3166-1 alpha-3 country codes, but tbl_GL_Country.IsoCode is alpha-2.
 * Covers the countries Adora operates in — add a line when a new one is onboarded.
 */
const ALPHA3_TO_ALPHA2: Record<string, string> = {
    BHS: "BS",
    CAN: "CA",
    ESP: "ES",
    GBR: "GB",
    MEX: "MX",
    PRI: "PR",
    USA: "US"
};

const ALPHA2_TO_ALPHA3: Record<string, string> = Object.fromEntries(
    Object.entries(ALPHA3_TO_ALPHA2).map(([alpha3, alpha2]) => [alpha2, alpha3])
);

export function toAlpha2CountryCode(countryCode?: string): string | undefined {
    if (!countryCode) return undefined;

    const normalized = countryCode.trim().toUpperCase();
    return ALPHA3_TO_ALPHA2[normalized] ?? countryCode;
}

/**
 * HERE's `in=countryCode:` filter takes uppercase alpha-3 codes. A code with no mapping is
 * dropped rather than passed through, so an unknown country widens the search instead of
 * making HERE reject the whole request.
 */
export function toAlpha3CountryCodes(countryCodes: readonly string[]): string[] {
    const mapped = countryCodes
        .map(code => ALPHA2_TO_ALPHA3[code?.trim().toUpperCase()])
        .filter((code): code is string => Boolean(code));

    return Array.from(new Set(mapped));
}
